custom.optimizelyHandler = (() => {
  const optimizelElemClassName = 'js-optimizely';
  const optimizelyInitClassName = 'js-optimizely--initialized';

  function initClassHandler(elem = null) {
    if (!$(elem).hasClass(optimizelyInitClassName))
      $(elem).addClass(optimizelyInitClassName);
  }

  function pushDataLayer(e = null) {
    if (!window.trackOptimizelyEvent) return;

    // make sure all required tags are there
    const elem = $(this);

    // default GAEvent if undefined as data attribute
    let event = elem.data('event') ? elem.data('event') : 'OptimizelyEvent';

    // If undefined, get the closest element up that has a category
    const category = elem.data('category')
      ? elem.data('category')
      : elem.closest('[data-category]').data('category');

    // If undefined, get the closest element up that has a action
    const action = elem.data('action')
      ? elem.data('action')
      : elem.closest('[data-action]').data('action');

    // if you do not define the label, it will try to find text
    // inside the documentElement as a backup
    const label = elem.data('label') ? elem.data('label') : '';

    // Only used for MAP Pricing custom Event Property
    if (event === 'add-to-cart-clicked') {
      switch (category) {
        case 'MAP':
          event += '-map';
          break;
        case 'No MAP':
          event += '-no-map';
          break;
        case 'N/A':
          event += '-na';
          break;
      }
    }

    // Prepare the payload object
    let tags = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    };
    window.trackOptimizelyEvent(event, tags);
  }

  function init() {
    $.each($(`.${optimizelElemClassName}`), (index, elem) => {
      if (!$(elem).hasClass(optimizelyInitClassName))
        $(elem).on('click', pushDataLayer);
      initClassHandler($(elem));
    });
    /* DISABLED - no active experiment
    // EXPERIMENT SPECIFIC TRACKING GOES HERE
    const currentUrl = window.location.href;
    if (
      currentUrl &&
      currentUrl.indexOf('/products/') > -1 &&
      window.trackOptimizelyEvent
    ) {
      window.trackOptimizelyEvent('PDP View', {
        eventCategory: 'Page View',
      });
    }
    */
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/optimizely-handler.js